import { apiHost } from "consts";
import CardSample from "features/cases/blocks/CommonCard";
import { useTexts } from "hooks/useTexts";
import React from "react";

type AddContentCardProps = {
  kind: "problem" | "solution";
  problemId?: string;
  sphere?: any;
};

const AddContentCard: React.FC<AddContentCardProps> = ({
  kind,
  problemId,
  sphere,
}) => {
  const { txt } = useTexts("case");
  const isSolution = kind === "solution";

  return (
    <CardSample
      parentData={{
        isProblem: !isSolution,
        isSolution,
        isAttribute: false,
        sphereId: sphere,
        ...(isSolution && { problemId }),
      }}
      sectionTitle={
        isSolution
          ? txt("solution_create", "Создание решения")
          : txt("problem_create", "Создание проблемы")
      }
      title={
        isSolution
          ? txt("new_solution", "Новое решение")
          : txt("new_problem", "Новая проблема")
      }
      key="new"
      autoModalOpen={true}
      addUrl={`${apiHost}/admin/solutions/${isSolution ? "solutions" : "problems"}/add/`}
    />
  );
};

export default AddContentCard;
